import { render, staticRenderFns } from "./DashboardCard.vue?vue&type=template&id=acad1304&"
import script from "./DashboardCard.vue?vue&type=script&lang=js&"
export * from "./DashboardCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acad1304')) {
      api.createRecord('acad1304', component.options)
    } else {
      api.reload('acad1304', component.options)
    }
    module.hot.accept("./DashboardCard.vue?vue&type=template&id=acad1304&", function () {
      api.rerender('acad1304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/peach-pear-plum/components/peach/DashboardCard.vue"
export default component.exports